goog.provide("shadow.js.shim.module$src$svg$artwork$folder_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$folder_svg");
shadow.js.shim.module$src$svg$artwork$folder_svg = shadow.js.nativeProvides["src/svg/artwork/folder.svg"] = shadow$bridge("src/svg/artwork/folder.svg");
module$shadow_js_shim_module$src$svg$artwork$folder_svg.default = shadow.js.shim.module$src$svg$artwork$folder_svg;
